module.exports = __webpack_public_path__ + "img/logo-02-sea.7a175298.png";